import { useEffect, useState } from "react";

/**
 * @function useScreenOrientation
 * @description a simple hook to return the current screen orientation. It uses media queries rather than ScreenOrientation API due to patchy browser support
 * @todo eventually this hook can be converted to use the ScreenOrientation API once there is better support (Safari)
 * @see {@link https://fjolt.com/article/javascript-detecting-device-orientation Detecting Device Orientation with Javascript}
 */
export const useScreenOrientation = () => {
  const [orientation, setOrientation] = useState<OrientationType>();
  useEffect(() => {
    const getOrientationType = (): OrientationType =>
      portrait.matches ? "portrait-primary" : "landscape-primary";
    const updateOrientation = () => {
      setOrientation(getOrientationType());
    };
    const portrait = window.matchMedia("(orientation: portrait)");
    portrait.addEventListener("change", updateOrientation);

    updateOrientation();
    return () => {
      portrait.removeEventListener("change", updateOrientation);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isPortrait =
    orientation === "portrait-primary" || orientation === "portrait-secondary";

  const isLandscape =
    orientation === "landscape-primary" ||
    orientation === "landscape-secondary";

  return { orientation, isPortrait, isLandscape };
};
